// Mock content data for Holistic Intuitive Nutrition - Kamla Das clone
// All content is frontend-only. External actions link to real zcal / Google Form URLs.

export const LINKS = {
  bookCall: "https://zcal.co/coachkam/30min",
  freeChart: "https://docs.google.com/forms/d/e/1FAIpQLSeAsVchFVfQFH7MobBUbazBGypDwaXVWjJGJwJdRSqew2vNkQ/viewform",
  facebook: "https://www.facebook.com/",
};

export const SOCIAL = {
  facebook: "https://www.facebook.com/groups/IntuitiveWmensWellnessAndSpiritualAstrology",
  instagram: "https://www.instagram.com/holisticintuitivenutrition/?hl=en",
};

export const CONTACT_INFO = {
  brand: "Holistic Intuitive Nutrition",
  year: "2026",
  location: "North Carolina, United States of America",
  email: "coachkam99@gmail.com",
  phone: "727 404 2693",
};

export const LEGAL = {
  privacyTitle: "Privacy Policy and Disclaimer",
  privacyText:
    "All images, graphics and written content on this site are protected by copyright and may not be used for any reason other than information without express written notice by the copyright owner. By interacting with this site you authorize Kamla Das of Holistic Intuitive Nutrition to contact you from time to time with meaningful information. This can be discontinued at any time by emailing us.",
};

export const YOUTUBE = {
  videoId: "mRxbkflGUyo",
  title: "Health Is Your Wealth",
  channel: "Kamla Das",
  caption:
    "Watch as Kamla Das shares why your health is truly your wealth.",
  thumbnail: "https://img.youtube.com/vi/mRxbkflGUyo/maxresdefault.jpg",
};

export const IMAGES = {
  kamlaAbout:
    "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221440/53124332-918d-4f29-920c-e3d5dd659997.jpg",
  servicesHero:
    "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/222435/e7fd479d-414d-4f01-ab1a-0447ce4321e7.jpg",
  astro1:
    "https://static.prod-images.emergentagent.com/jobs/2e3ef4c7-1e8d-4338-9379-167d7910f0de/images/c7064c60b25d0e0e630becf07a4b5a4be1758bd172d30a505294801176af42e3.jpeg",
  astro2:
    "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/225129/426ace7c-fc8e-4aa5-bf53-b52f8a60f9e1.jpg",
  contactKamla:
    "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221450/6af011e0-9a98-4ec9-8ad9-42461f728ec0.jpg",
  contactBanner:
    "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221450/b84e887c-769a-4459-97b0-ec89c9255ffa.jpg",
};

export const HOME_TESTIMONIALS = [
  {
    name: "Sandra McRaven Massey",
    image:
      "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221440/139a1e5f-32f0-4ab6-b605-8255dcffdfd7.jpg",
    quote:
      "Kamla has exceptional skills and dedication in holistic health care, mentoring, coaching, and astrology teaching. She specializes in working with women who have experienced abuse, offering much needed emotional support and guidance. Her approach is holistic, addressing not just physical health, but mental, emotional, and spiritual well being. She creates a safe, welcoming space where clients can share without judgment, and has a remarkable ability to explain complex astrological concepts in simple terms. Her compassion, empathy, and professionalism leave a profound impact on the lives of everyone she works with.",
  },
  {
    name: "Melissa Hughes, Ph.D",
    image:
      "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221440/2302c6a0-78bb-474f-b743-b4b19fe475ac.jpg",
    quote:
      "Kamla is not only knowledgeable; she shares her expertise in a way that makes others understand and want to learn more. She is curious and open, and takes the time to know the people she is working with so she can connect authentically and create a meaningful exchange. I have learned so much from Kamla and highly recommend her to anyone interested in learning more about themselves.",
  },
  {
    name: "Dennis J. Pitocco, Chief Reimaginator, 360° Nation",
    image:
      "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221440/ec97552d-3c7d-4375-bec4-5eff2b85f344.jpg",
    quote:
      "The world needs more people like Kamla, who turn their wisdom of experience into a force that challenges the world to change for the better. A consummate professional, her unique, nurturing, holistic guidance sets her apart. Her candor and keen insights equip those she meets with the ability to break through everyday challenges by embracing a 'rise above and learn from it all' ethos. Kamla's strength of character and passion are rare and set a worthy standard for others to follow.",
  },
];

export const ABOUT_TEXT = [
  "Hello! I'm Kamla Das, a Certified PEMF, Red Light & Holistic Health Care Practitioner, Author, and devoted Mother. My professional journey has been shaped by a rich tapestry of experiences, including collaborative work with Dr. Teri Stokes at Natural Treatments for Brain & Body.",
  "I have chosen to specialize in working with women who have experienced abuse, offering much needed emotional support and guidance. Inspired by a fusion of Eastern and Western modalities, I have crafted a distinctive approach to holistic well being, centered around fostering a Healthy Mind, Body and Soul with a dedicated focus on Nutrition and Wellness.",
  "At HIN, we teach alternate nostril breathing alongside meditation as a simple practice to support greater calm, clarity, and balance. Scientists and medical researchers have studied alternate nostril breathing and found measurable effects on the human body, particularly involving the brain, heart, and nervous system.",
  "Join me on this transformative journey toward a healthier, more balanced, and harmonious lifestyle. Together, let's navigate the path to positive choices and vibrant well being.",
];

export const SERVICE_INTRO = {
  title: "Why HIN Living?",
  body:
    "Everyone's body is different and has unique nutritional requirements driven by differences in anatomy, metabolism, body composition and cell structure. We honor the principle of bio individuality. Our holistic, drug free approach uses EFT, essential oils, meditation, intuitive practices, PEMF and Red Light sessions to help you stay calm, focused, and balanced. Our journey begins with a comprehensive health history, followed by a complimentary initial virtual consultation to understand your specific needs, and to ensure we are the right fit for each other.",
  redlight:
    "Red Light uses specific wavelengths of light to reach deep into the cells, boosting mitochondrial energy, improving circulation, reducing inflammation, and supporting skin health, muscle recovery, and overall cellular function.",
  pemf:
    "PEMF Therapy gently stimulates the body with low frequency electromagnetic pulses that help recharge cells, enhance oxygenation, improve circulation, reduce pain, and support deeper relaxation. Combined, these therapies help the body restore balance, increase energy, reduce stress, and promote faster healing.",
};

export const SIGNATURE_BENEFITS = [
  {
    n: "01",
    title: "Holistic Health Assessment",
    body:
      "Begin your wellness journey with a thorough holistic health assessment. Our practitioner evaluates various aspects of your life, including physical health, mental well being, nutrition, and lifestyle choices.",
  },
  {
    n: "02",
    title: "Personalized Wellness Plan",
    body:
      "Receive a personalized wellness plan tailored to your unique needs and goals, integrating holistic practices, nutritional guidance, and lifestyle recommendations to promote overall well being.",
  },
  {
    n: "03",
    title: "Holistic Health Mentoring",
    body:
      "Explore the transformative power of holistic nutrition. We guide you in mindful food choices, gentle fitness sessions (yoga, Qi Gong, Tai Chi, meditation), and rejuvenating energy healing sessions.",
  },
  {
    n: "04",
    title: "Progress Tracking & Assessment",
    body:
      "Regularly monitor your progress with follow up assessments. We make the necessary adjustments to your wellness plan, ensuring it evolves along with your changing health needs.",
  },
  {
    n: "05",
    title: "Community Support",
    body:
      "Join a supportive community of individuals on similar wellness journeys. Share experiences, gain inspiration, and foster connections that contribute to a positive and uplifting environment.",
  },
];

export const ADDITIONAL_PROGRAMS = [
  {
    title: "'Holistic Harmony' Mentoring Program",
    intro:
      "An integrated approach to enhancing not just your physical health, but also your wealth and relationships, creating a harmonious balance between your well being, financial goals, and the richness of your personal connections.",
    components: [
      "Holistic Health and Wellness Mentoring",
      "Relationship Enhancement Sessions",
      "Mindful Living Practices",
      "Nutrition for Wealth and Well Being",
      "Financial Goal Setting and Accountability",
      "Community Connection Events",
    ],
  },
  {
    title: "Mind, Body, Soul & Spirit Program",
    intro:
      "Also available as the 'Whole Body Wellness' Mentoring Program. Embark on a holistic journey of self discovery, achieving balance and harmony across your mind, body, soul, and spirit, specially crafted to nurture every aspect of your being.",
    components: [
      "Mindful Mindset Mentoring",
      "Body Nourishing Nutrition Guidance",
      "Soulful Fitness and Movement",
      "Spiritual Connection and Exploration",
      "Energy Healing and Spiritual Alignment",
      "Community Wellness Circles",
    ],
  },
];

export const SERVICE_TESTIMONIAL =
  "A life changing mentor! My life would not be the same without Kamla. From creating a custom food and health plan to introducing me to the world of essential oils and energy healing, her unwavering support helped me stay focused and achieve remarkable results. When I received my health report, my doctors were astonished by the excellent results. If you're looking to make positive changes in your life, I highly recommend Kamla.";

export const ASTRO_PARAGRAPHS = [
  "Astrologers believe that the positions of the sun, moon, and planets at the time of birth have a great influence on a person's life. Astrology is not separate, it is part of the whole; as above, so below. It is part of science, mathematics, geography, astronomy, and much more.",
  "Just as a meteorologist uses data to 'predict' the weather, astrology can guide us in personal and business decisions, helping us make plans for our daily life and future. Astrology can be mystical or simple, it depends on what you want to learn.",
  "Astrology has been used, now and in the past, by presidents, churches, businesses and everyday people. It is more than entertainment, it is a tool. Learn the meaning of your ascendant sign, and the difference between your sun and moon sign, and discover how you can benefit from astrology.",
];

export const ASTRO_YOGANANDA =
  "In Paramahansa Yogananda's Autobiography of a Yogi, his guru Sri Yukteswar, a renowned astrologer and astronomer, says: \"It is never a question of belief; the only scientific attitude one can take on any subject is whether it is true. All parts of creation are linked together and interchange their influences. The balanced rhythm of the universe is rooted in reciprocity. A child is born on that day and at that hour when the celestial rays are in mathematical harmony with his karma. His horoscope is a challenging portrait, revealing his unalterable past and its probable future results.\"";

export const ASTRO_CHART = {
  title: "What your astrology chart can tell you",
  body:
    "A birth chart is a celestial snapshot of the universal energies at play the moment you arrive on this planet. It provides a roadmap to understanding how you became YOU. By entering your birthday, time, and location of birth, you can find out if you are a cusp sign and what that means; the exact placements of all your planets (Uranus, Saturn, Jupiter, etc.); and how the planets' interactions impact your overall horoscope.",
  note:
    "For the most accurate birth chart analysis, you will need your date of birth as well as the hour, minute, and place of birth. If you are unable to get the exact time, make the closest possible estimate or enter 12:00 noon.",
};

export const ASTRO_TESTIMONIALS = [
  {
    name: "Angela B.",
    quote:
      "Kamla completed my Natal report while working with me on some issues I was experiencing. It perfectly described me, so I am a believer now. She used it as practical knowledge to help me understand why I was thinking a certain way. She also taught me to use EFT and SRT to deal with the issues life throws at us. Kamla applied her skills patiently and non judgmentally during a time with a lot of overwhelming changes. I am extremely grateful.",
  },
  {
    name: "Janet B.",
    quote:
      "The astrological charts Kamla provided for my daughter were nothing short of astounding. The level of detail and accuracy was impressive, shedding light on aspects of her personality and life we had never considered before. Her ability to interpret the charts and convey their significance in a clear, relatable manner was truly enlightening. I highly recommend Kamla's astrological services to anyone seeking a better understanding of themselves or their loved ones.",
  },
];

export const CONTACT_TESTIMONIALS = [
  {
    name: "Sandra McRaven Massey",
    image:
      "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221450/df6ec9a8-857f-421f-826d-5a2ffad85ba5.jpg",
    quote:
      "Kamla has exceptional skills and dedication in the field of holistic health care, mentoring, coaching, and astrology teaching. Her approach is holistic, ensuring she addresses the comprehensive well being of her clients, not just their physical health, but also mental, emotional, and spiritual aspects.",
  },
  {
    name: "Barbara R.",
    image:
      "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221450/e58afbd5-5a70-4ab5-afdd-95b91e8d64ed.jpg",
    quote:
      "My dog Lady got hurt and could not walk, she was in a lot of pain. Kamla massaged her with essential oils, and within a few minutes Lady's pain eased and she was able to walk again. I am very grateful; I never knew what essential oils could do for animals and people.",
  },
  {
    name: "Janet B.",
    image:
      "https://s3-us-west-2.amazonaws.com/sticky-folio-uploads/res3000/221450/6545addd-d4d7-4f0e-856f-ffaf767b97ed.jpg",
    quote:
      "Since incorporating essential oils into my daily routine, I have experienced a significant improvement in my health. I've been able to control my stress and blood pressure without medication. Kamla's guidance in selecting the right essential oils and teaching me how to use them effectively has been invaluable.",
  },
];

// Dedicated Testimonials page — mock social proof across all of Kamla's services.
const _img = (id) =>
  `https://images.unsplash.com/photo-${id}?ixlib=rb-4.1.0&auto=format&fit=crop&crop=faces&w=320&h=320&q=80`;

export const TESTIMONIALS_INTRO =
  "Real transformations from the women Coach Kam has walked beside, through holistic healing, astrology, recovery from abuse and narcissistic relationships, and the quiet power of meditation. Every one of them wholeheartedly recommends Coach Kam.";

export const TESTIMONIALS = [
  {
    name: "Jane B.",
    role: "Holistic Health Client",
    service: "Holistic Health",
    rating: 5,
    image: _img("1580489944761-15a19d654956"),
    quote:
      "Coach Kam completely changed how I care for my body. Her PEMF and Red Light sessions, paired with a nutrition plan built just for me, gave me energy I hadn't felt in years. When my bloodwork came back, my doctor was stunned by the improvement. I recommend Coach Kam to every woman ready to reclaim her health.",
  },
  {
    name: "Ashley R.",
    role: "Wellness Coaching",
    service: "Holistic Health",
    rating: 5,
    image: _img("1757348665310-0b68ed0ebc30"),
    quote:
      "What sets Coach Kam apart is how she treats the whole person, mind, body, and spirit. She listened without judgment, tailored everything to my life, and held me accountable with such warmth. My stress and blood pressure are finally under control, drug free. I strongly recommend Coach Kam.",
  },
  {
    name: "Angela B.",
    role: "Astrology Client",
    service: "Astrology",
    rating: 5,
    image: _img("1494790108377-be9c29b29330"),
    quote:
      "My Natal report was uncannily accurate, it explained why I think and react the way I do. Coach Kam used it as practical guidance, not just prediction, and taught me EFT to handle life's overwhelm. I'm a believer now. I recommend Coach Kam to anyone seeking real self understanding.",
  },
  {
    name: "Chloe M.",
    role: "Astrology Client",
    service: "Astrology",
    rating: 5,
    image: _img("1662850886700-4ec19bd30d11"),
    quote:
      "The birth chart Coach Kam prepared for my daughter was astounding in its detail and accuracy. She interprets the stars in a way that's clear, relatable, and genuinely helpful. My whole family benefited from her insight. I highly recommend Coach Kam's astrology services.",
  },
  {
    name: "Rachel M.",
    role: "Domestic Abuse Survivor",
    service: "Domestic Violence Recovery",
    rating: 5,
    image: _img("1662850886700-4ec19bd30d11"),
    quote:
      "After leaving an abusive marriage, I was broken and afraid. Coach Kam created a safe, judgment free space where I could finally breathe. She helped me rebuild my confidence, my health, and my sense of safety one step at a time. She saved my life, honestly. I recommend Coach Kam to any survivor.",
  },
  {
    name: "Denise T.",
    role: "Domestic Abuse Survivor",
    service: "Domestic Violence Recovery",
    rating: 5,
    image: _img("1783953589389-d9f4ebfaa49b"),
    quote:
      "I came to Coach Kam carrying years of trauma. Her gentle, holistic approach, EFT, essential oils, and so much compassion, helped me release fear I'd held onto for decades. For the first time in years, I feel like myself. I strongly recommend Coach Kam to women rebuilding after abuse.",
  },
  {
    name: "Priya S.",
    role: "Domestic Abuse Survivor",
    service: "Domestic Violence Recovery",
    rating: 5,
    image: _img("1688398171825-b9fd03b5d062"),
    quote:
      "Coach Kam specializes in supporting women who've experienced abuse, and it shows in everything she does. She met me exactly where I was, never rushing, never judging. She gave me tools and hope. I wouldn't be where I am today without her. I recommend Coach Kam wholeheartedly.",
  },
  {
    name: "Karen W.",
    role: "Narcissistic Abuse Recovery",
    service: "NPD Recovery",
    rating: 5,
    image: _img("1757348665310-0b68ed0ebc30"),
    quote:
      "Recovering from a relationship with a narcissist left me doubting my own reality. Coach Kam helped me understand the patterns, rebuild my boundaries, and stop the self blame. Her guidance was a lifeline through the fog. I recommend Coach Kam to anyone healing from narcissistic abuse.",
  },
  {
    name: "Lauren P.",
    role: "Narcissistic Abuse Recovery",
    service: "NPD Recovery",
    rating: 5,
    image: _img("1729202305341-d146fdea0a03"),
    quote:
      "Coach Kam understands narcissistic abuse in a way few people do. She validated everything I'd been through and gave me a clear path forward, grounding practices, EFT, and steady encouragement. I finally feel free. I strongly recommend Coach Kam to every survivor of NPD relationships.",
  },
  {
    name: "Teresa V.",
    role: "Narcissistic Abuse Recovery",
    service: "NPD Recovery",
    rating: 5,
    image: _img("1757348665310-0b68ed0ebc30"),
    quote:
      "Recovering from a narcissistic relationship left me second guessing everything. Coach Kam validated what I'd been through and gave me a clear path forward, grounding practices, EFT, and steady encouragement. I finally feel like myself again. I recommend Coach Kam to anyone healing from narcissistic abuse.",
  },
  {
    name: "Monica L.",
    role: "Meditation Student",
    service: "Meditation",
    rating: 5,
    image: _img("1506863530036-1efeddceb993"),
    quote:
      "Coach Kam's guided meditations are pure magic. She taught me to slow my breath, quiet my mind, and find calm even on the hardest days. My anxiety has dropped dramatically. I look forward to every session. I recommend Coach Kam to anyone craving more peace.",
  },
  {
    name: "Elaine H.",
    role: "Meditation & Mindfulness",
    service: "Meditation",
    rating: 5,
    image: _img("1580489944761-15a19d654956"),
    quote:
      "I never thought I could meditate, my mind was always racing. Coach Kam's gentle, intuitive guidance made it effortless. Her meditations helped me sleep better, stress less, and reconnect with myself. I strongly recommend Coach Kam to anyone new to meditation.",
  },
  {
    name: "Barbara R.",
    role: "Holistic Health Client",
    service: "Holistic Health",
    rating: 5,
    image: _img("1494790108377-be9c29b29330"),
    quote:
      "Coach Kam introduced me to essential oils and energy healing, and the results speak for themselves. My chronic pain eased, my sleep improved, and I feel balanced again. She's knowledgeable, patient, and deeply caring. I recommend Coach Kam to anyone seeking natural healing.",
  },
  {
    name: "Grace N.",
    role: "Wellness Client",
    service: "Holistic Health",
    rating: 5,
    image: _img("1688398171825-b9fd03b5d062"),
    quote:
      "Coach Kam's holistic approach turned my health around. Between the Red Light therapy, nutrition coaching, and her constant encouragement, I gained energy I hadn't had in a decade. My doctor is amazed. I highly recommend Coach Kam.",
  },
  {
    name: "Sofia D.",
    role: "Astrology & Coaching",
    service: "Astrology",
    rating: 5,
    image: _img("1662850886700-4ec19bd30d11"),
    quote:
      "Coach Kam combines astrology with practical coaching in a way I've never seen. Understanding my chart gave me clarity about my relationships and career, and she helped me act on it. She's insightful, warm, and genuine. I recommend Coach Kam without hesitation.",
  },
  {
    name: "Naomi K.",
    role: "Holistic Health & Meditation",
    service: "Meditation",
    rating: 5,
    image: _img("1729202305341-d146fdea0a03"),
    quote:
      "From guided meditations to holistic health mentoring, Coach Kam has transformed my daily life. I'm calmer, healthier, and more grounded than ever. She truly cares about every client. I recommend Coach Kam to anyone ready for real, lasting change.",
  },
];

export const CONTACT_HOURS = {
  title: "Hours of Operation",
  body:
    "Tuesday through Friday, 10:00 a.m. to 7:00 p.m. EST. Appointments are also available on weekends and after hours. Proudly serving clients worldwide through our remote services.",
  location: "Based in North Carolina, USA, with a global reach.",
};

export const OTHER_HELP = [
  {
    title: "Emotional Freedom Technique (EFT)",
    body:
      "EFT is a versatile healing tool with the potential to deliver remarkable results for physical, emotional, and performance related issues. It operates on the principle that unresolved emotional issues can hinder improvement in any aspect of life. Often, stress and negative emotions impact the quality of our breath, and we frequently underestimate the connection between our breath and our emotional state.",
  },
  {
    title: "Essential Oils",
    body:
      "Inhaling essential oils can affect the body through several systems and pathways. Learn how to use essential oils safely, how to use, store and purchase them, for emotional, intellectual, spiritual, and physical health. We offer a drug free approach to better manage stressful situations using the Emotional Freedom Technique, essential oils, and meditation.",
  },
  {
    title: "Astrology",
    body:
      "Astrologers believe the positions of the Sun, Moon, and planets at the time of birth have a great influence on a person's life. Astrology is part of the whole, science, mathematics, geography, and astronomy. Learn the meaning of your ascendant sign, and the difference between your sun and moon sign.",
  },
];
